module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/kv_bg@sp-a135ff5715e9ab4038c2e8e66afc92d2.jpg";